import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var ReturnedToSenderIA = function ReturnedToSenderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9LbFDA",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je een bestelling hebt proberen te verzenden en deze vervolgens naar je is teruggestuurd, kan dit vanwege verschillende redenen zijn. Bekijk onze "
    }, {
      "children": [{
        "type": 0,
        "value": "gedetailleerde gids"
      }],
      "type": 8,
      "value": "ArticleLinkFormatting"
    }, {
      "type": 0,
      "value": " over "
    }, {
      "children": [{
        "type": 0,
        "value": "problemen met teruggestuurde zendingen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " om de aanbevolen vervolgstappen te vinden, voor zowel binnenlandse als internationale zendingen."
    }],
    values: {
      ArticleLinkFormatting: ArticleLinkFormatting,
      BoldFormatting: BoldFormatting
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1gsUye",
    defaultMessage: [{
      "type": 0,
      "value": "Neem contact met ons op voor meer hulp. Wij helpen graag."
    }]
  })));
};
var ArticleLinkFormatting = function ArticleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("26594585812891"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};